import React, { useEffect, useState } from "react";
import Colors from "../config/Colors";
import {
  FaGooglePlay,
  FaAppStoreIos,
  FaLayerGroup,
  FaBell,
} from "react-icons/fa";
import { MdContactMail } from "react-icons/md";
import "./styles/Home.css";
import Footer from "../components/Footer";

const Home = () => {
  const [isHovered, setIsHovered] = useState(false);
  const [isHovered1, setIsHovered1] = useState(false);
  const [windowWidth, setWindowWidth] = useState(window.innerWidth);
  const isMobile = windowWidth <= 768;

  useEffect(() => {
    const handleResize = () => setWindowWidth(window.innerWidth);

    window.addEventListener("resize", handleResize);
    return () => window.removeEventListener("resize", handleResize);
  }, []);

  function IconButtons() {
    return (
      <div
        style={{
          display: "flex",
          gap: "15px",
          fontSize: "30px",
          flexDirection: "column",
          paddingLeft: isMobile ? 0 : "10%",
        }}
      >
        <div
          onMouseEnter={() => setIsHovered(true)}
          onMouseLeave={() => setIsHovered(false)}
          style={{
            display: "flex",
            alignItems: "center",
            marginBottom: "15%",
            padding: "10px",
            justifyContent: "center",
            height: "30%",
            width: "100%",
            borderRadius: 10,
            backgroundColor: isHovered ? Colors.dialogHead : Colors.black,
            boxShadow: "0 4px 8px rgba(0, 0, 0, 0.2)",
          }}
        >
          <a
            style={{
              color: Colors.white,
              textDecoration: "none",
              display: "flex",
              alignItems: "center",
              flexDirection: "column",
            }}
            href="https://play.google.com/store/apps/details?id=com.app.trackmateforce"
            target="_blank"
            rel="noopener noreferrer"
          >
            <div style={{ display: "flex" }}>
              <FaGooglePlay style={{ paddingRight: 5, fontSize: 25 }} />
              <span style={{ fontSize: 18 }}>GET IT ON</span>
            </div>
            <span style={{ fontSize: 25 }}>{"Google Play"}</span>
          </a>
        </div>
        <div
          onMouseEnter={() => setIsHovered1(true)}
          onMouseLeave={() => setIsHovered1(false)}
          style={{
            padding: "10px",
            display: "flex",
            justifyContent: "center",
            height: "30%",
            width: "100%",
            borderRadius: 10,
            backgroundColor: isHovered1 ? Colors.dialogHead : Colors.black,
            boxShadow: "0 4px 8px rgba(0, 0, 0, 0.2)",
          }}
        >
          <a
            style={{
              color: Colors.white,
              textDecoration: "none",
              display: "flex",
              alignItems: "center",
              flexDirection: "column",
            }}
            href="https://apps.apple.com/app/id6764128725"
            target="_blank"
            rel="noopener noreferrer"
          >
            <span style={{ fontSize: 20 }}>Download on the</span>

            <div style={{ display: "flex" }}>
              <FaAppStoreIos style={{ paddingRight: 5, fontSize: 25 }} />

              <span style={{ fontSize: 25 }}>{"App Store"}</span>
            </div>
          </a>
        </div>
      </div>
    );
  }

  function FirstPart() {
    return (
      <div
        className="hero-container"
        style={{ zIndex: 1, justifyContent: "center", display: "flex" }}
      >
        <div
          className="hero-content"
          style={{ zIndex: 1, justifyContent: "center", display: "flex" }}
        >
          <h1 className="hero-title">
            <span style={{ fontSize: 35 }}>Welcome to</span> Track Mate
          </h1>
          <IconButtons />
        </div>
      </div>
    );
  }

  const ThreeColumnSection = () => {
    const containerStyle = {
      display: "flex",
      flexWrap: "wrap",
      justifyContent: "space-between",
      gap: "1rem",
      padding: "1rem",
      alignItems: "center",
      // marginBottom:10,
    };

    const columnStyle = {
      flex: "1",
      minWidth: "280px",
      padding: "1.5rem",
      borderRadius: "8px",
      textAlign: "center",
    };

    const iconStyle = {
      fontSize: "5rem",
      color: Colors.white,
      marginBottom: "1rem",
    };

    const titleStyle = {
      fontSize: "1.4rem",
      fontWeight: "bold",
      color: Colors.gold,
      marginBottom: "0.5rem",
    };

    const descStyle = {
      fontSize: "0.95rem",
      color: Colors.lineGrey,
    };

    const sections = [
      {
        icon: <FaLayerGroup style={iconStyle} />,
        title: "Multiple Categories",
        desc: "Create and manage different types of records based on your needs. Whether it's expenses, personal notes, tasks, subscriptions, or custom categories, keep everything organized and easy to access.",
      },
      {
        icon: <FaBell style={iconStyle} />,
        title: "Smart Reminders",
        desc: "Never miss an important task or event. Set reminders for your records and receive timely notifications to help you stay on top of payments, deadlines, appointments, and other important activities.",
      },
      {
        icon: <MdContactMail style={iconStyle} />,
        title: "Support",
        desc: "We value our users and enabled best support team to answer your queries. Users can contact us for any help by the option provided in the app. Our support team will catch it as soon as possible.",
      },
    ];

    return (
      <div className="hero-content" style={containerStyle}>
        {sections.map((sec, index) => (
          <div key={index} style={columnStyle}>
            {sec.icon}
            <div style={titleStyle}>{sec.title}</div>
            <div style={descStyle}>{sec.desc}</div>
          </div>
        ))}
      </div>
    );
  };

  function LastPart() {
    return (
      <div
        className="hero-container"
        style={{
          zIndex: 1,
          justifyContent: "center",
          display: "flex",
          marginBottom: 50,
        }}
      >
        <div
          className="hero-content"
          style={{ zIndex: 1, justifyContent: "center", display: "flex" }}
        >
          <h1 className="hero-title">
            <span style={{ fontSize: 35 }}>About Track Mate</span>
          </h1>
          <div
            style={{
              display: "flex",
              gap: "15px",
              fontSize: "30px",
              flexDirection: "column",
              paddingLeft: isMobile ? 0 : "10%",
            }}
          >
            <p style={{ fontSize: 20, color: Colors.lineGrey }}>
              Track and organize your daily activities in one place. Manage
              expenses, notes, reminders, and other important records with a
              simple and efficient tracking system designed to help you stay
              organized and productive.
            </p>
          </div>
        </div>
      </div>
    );
  }

  return (
    <div style={styles.containerOuter}>
      <div
        className="hero-container"
        style={{
          transform: "translate(0%, -25%)",
          position: "absolute",
          top: "0%",
          height: "100%",
          zIndex: -10,
          overflow: "hidden",
        }}
      ></div>

      <FirstPart />

      <ThreeColumnSection />

      <LastPart />
      <Footer isMobile={isMobile} />
    </div>
  );
};

const defaultStyles = {
  container: {
    width: "100%",
    margin: "0 auto",
    // padding: "2%",
  },
  text: {
    fontSize: "2vw", // scales with screen width
    lineHeight: "1.5em",
  },
  textSmall: {
    fontSize: "1.5vw", // scales with screen width
    lineHeight: "1.2em",
  },
  textBig: {
    fontSize: "1.8vw", // scales with screen width
    lineHeight: "1.2em",
  },
  textExtraSmall: {
    fontSize: "1vw", // scales with screen width
    lineHeight: "1.2em",
  },
};

const styles = {
  containerOuter: {
    ...defaultStyles.container,
    display: "flex",
    alignItems: "center",
    flexDirection: "column",
    zIndex: 1,
    overflow: "hidden",
  },
  container: {
    borderWidth: 1,
    borderColor: "#ccc",
    borderRadius: 8,
    width: "50%",
    overflow: "hidden",
    alignItems: "center",
    justifyContent: "center",
    marginVertical: 10,
    paddingTop: 50,
  },
  header: {
    ...defaultStyles.text,
    backgroundColor: Colors.white,
    padding: "20px 16px",
    color: Colors.black,
    fontWeight: "bold",
    cursor: "pointer",
    userSelect: "none",
    alignItems: "center",
    justifyContent: "space-between",
    display: "flex",
  },
  content: {
    paddingVertical: 12,
    paddingHorizontal: 16,
    padding: "20px 16px",
    backgroundColor: Colors.whiteLight,
    color: "#333",
    ...defaultStyles.textSmall,
  },
  space: {
    paddingRight: "2%",
  },
  spaceTop: {
    marginTop: "2%",
  },
  linkText: {
    textDecoration: "underline",
    paddingTop: 50,
    marginHorizontal: "1rem",
    paddingHorizontal: "5rem",
    cursor: "pointer",
    color: Colors.gold,
  },
};

export default Home;
